import { TypeAsnSource } from '../../interfaces/Asn/TypeAsnSource'
import { TypeAsnSourceAction } from '../actions/typeAsnSourceActions'
import { GET_TYPE_ASN_SOURCE_EXITO } from '../types/typeAsnSourceActionsTypes'

export interface TypeAsnSourceState {
  typeAsnSourceState: {
    typeAsnSource?: TypeAsnSource[]
    error?: string | undefined
  }
}

const initialState: TypeAsnSourceState = {
  typeAsnSourceState: { typeAsnSource: [], error: '' }
}

export const typeAsnSourceReducer = (
  state: TypeAsnSourceState = initialState,
  action: TypeAsnSourceAction
): TypeAsnSourceState => {
  if (action.type === GET_TYPE_ASN_SOURCE_EXITO) {
    return {
      ...state,
      typeAsnSourceState: {
        typeAsnSource: action.typeAsnSource,
        error: action.error
      }
    }
  }
  return state
}
